import React from "react";
import AccessoriesChooser from "./steps/accessories-chooser";
import DealerChooser from "./steps/dealer-chooser";
import BankIdAuthentication from "./steps/bankid-authentication";
import CustomerInformationInitial from "./steps/customer-information-initial";
import CustomerInformationDetails from "./steps/customer-information-details";
import DeliveryMethodChooser from "./steps/delivery-method-chooser";
import FinalConfirmation from "./steps/final-confirmation";
import FinalSummary from "./steps/final-summary";
import InsuranceAlternativeChooser from "./steps/insurance-alternative-chooser";
import InsuranceInformationDefinition from "./steps/insurance-information-definition";
import PaymentFinancingDetails from "./steps/payment-financing-details";
import PaymentMethodChooser from "./steps/payment-method-chooser";
import TradeInCarDefinition from "./steps/trade-in-car-definition";
import TradeInCarCondition from "./steps/trade-in-car-condition";
import TradeInConfirmCar from "./steps/trade-in-confirm-car";
import TradeInExistsChooser from "./steps/trade-in-exists-chooser";
import CreditAssessmentInformation from "./steps/credit-assessment/information/index";
import CreditAssessmentSigning from "./steps/credit-assessment/bankid/index";
import CreditAssessed from "./steps/credit-assessment/assessed/index";
import EcomStep from "./constants/ecom-step";
import Alert from "./components/alert";
import Spinner from "./components/spinner";
import { SOLD_TEXT } from "./constants/error-copy";
const SoldAlert = () => (React.createElement("div", { "data-ecom-alert": "error" },
    React.createElement("div", { className: "alert-icon-section" },
        React.createElement("div", { className: "alert-icon" },
            React.createElement("i", { className: "icon-exclamation no-margin" }))),
    React.createElement("div", { className: "alert-content" },
        React.createElement("span", { className: "font-medium" }, "\u00C5h nej, n\u00E5gon annan hann f\u00F6re! "),
        SOLD_TEXT)));
export default (props) => {
    if (!props.orderOptions && !props.isWaitingForResponse) {
        return (React.createElement(Alert, { message: "Ett ov\u00E4ntat fel har uppst\u00E5tt. Prova igen senare." }));
    }
    if (props.orderOptions && props.orderOptions.isUnavailable()) {
        return React.createElement(SoldAlert, null);
    }
    switch (props.step) {
        case EcomStep.DEALER_CHOOSER:
            return React.createElement(DealerChooser, Object.assign({}, props));
        case EcomStep.TRADE_IN_EXISTS_CHOOSER:
            return React.createElement(TradeInExistsChooser, Object.assign({}, props));
        case EcomStep.TRADE_IN_CAR_DEFINITION:
            return React.createElement(TradeInCarDefinition, Object.assign({}, props));
        case EcomStep.TRADE_IN_CAR_CONDITION:
            return React.createElement(TradeInCarCondition, Object.assign({}, props));
        case EcomStep.TRADE_IN_CONFIRM_CAR:
            return React.createElement(TradeInConfirmCar, Object.assign({}, props));
        case EcomStep.PAYMENT_METHOD_CHOOSER:
            return React.createElement(PaymentMethodChooser, Object.assign({}, props));
        case EcomStep.PAYMENT_FINANCING_DETAILS:
            return React.createElement(PaymentFinancingDetails, Object.assign({}, props));
        case EcomStep.BANKID_AUTHENTICATION:
            return React.createElement(BankIdAuthentication, Object.assign({}, props));
        case EcomStep.CREDIT_ASSESSMENT_INFORMATION:
            return React.createElement(CreditAssessmentInformation, Object.assign({}, props));
        case EcomStep.CREDIT_ASSESSMENT_SIGNING:
            return React.createElement(CreditAssessmentSigning, Object.assign({}, props));
        case EcomStep.CREDIT_ASSESSED:
            return React.createElement(CreditAssessed, Object.assign({}, props));
        case EcomStep.CUSTOMER_INFORMATION_INITIAL:
            return React.createElement(CustomerInformationInitial, Object.assign({}, props));
        case EcomStep.CUSTOMER_INFORMATION_DETAILS:
            return React.createElement(CustomerInformationDetails, Object.assign({}, props));
        case EcomStep.INSURANCE_INFORMATION_DEFINITION:
            return React.createElement(InsuranceInformationDefinition, Object.assign({}, props));
        case EcomStep.INSURANCE_ALTERNATIVE_CHOOSER:
            return React.createElement(InsuranceAlternativeChooser, Object.assign({}, props));
        case EcomStep.ACCESSORIES_CHOOSER:
            return React.createElement(AccessoriesChooser, Object.assign({}, props));
        case EcomStep.DELIVERY_METHOD:
            return React.createElement(DeliveryMethodChooser, Object.assign({}, props));
        case EcomStep.FINAL_SUMMARY:
            return React.createElement(FinalSummary, Object.assign({}, props));
        case EcomStep.FINAL_CONFIRMATION:
            return React.createElement(FinalConfirmation, Object.assign({}, props));
        default:
            if (props.isWaitingForResponse) {
                return React.createElement(Spinner, null);
            }
            return React.createElement("div", null);
    }
};
